import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Grid } from "../../../app/core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Helper } from "../../core/util/helper";
import { AppHelper } from "../../appHelper";
import { AppBaseProps, CommonApp, Entity, Metadata } from "../../core/components/commonApp";
import { SheetEventType } from "../../../siteManagement/sheet";
import { General } from "../../../siteManagement/general";
import { DialogHelper } from "../../core/util/dialogHelper";
import { NotificationHelper } from "../../core/util/notificationHelper";
import React from "react";


export default class SpesenGrid extends React.Component<any, { data: any[]}>{
    private laenderGruppen = {
        0: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Deutschland"),
        1: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.EuLand"),
        2: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Drittland"),
    };

    private gridOptions: kendo.ui.GridOptions = {
        sortable: true,
        pageable: false,
        groupable: false,
        filterable: true,
        selectable: true,
        resizable: true,
        scrollable: true,
        editable: false,
        columns: [
            {
                field: "Land",
                title: Helper.getTranslation("GeoMap.Country")
            },
            {
                field: "Iso",
                title: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.Landkf")
            },
            {
                field: "LandGruppe",
                title: Helper.getTranslation("WebSMS.GeneralSettings.Spesen.LaenderGruppe"),
                template: (dataItem) => {
                    return `<div>${(this.laenderGruppen[dataItem.LandGruppe])}</div>`;
                }
            }
        ]
    };
    private metaData: Metadata;


    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
        this.initApp();
    }

    private initApp = async () => {
        const [metaData, _] = await Promise.all([
            Helper.getMetaData("spesen"),
            this.getAll()
        ]);
        this.metaData = metaData;
        this.setState({})
    }

    private getAll = async () => {
        const result = await HTTPService.get<JsonResultClass<any[]>>("GeneralSettings/GetAllSpesen");
        this.setState({ data: result.Data });
    }

    private renderGrid = () => {

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Helper.getTranslation("Standard.Neu"), enabled: true },
            { type: ToolBarStandardButtonType.EDIT, caption: Helper.getTranslation("Standard.Editieren"), enabled: true },
            { type: ToolBarStandardButtonType.DELETE, caption: Helper.getTranslation("Standard.Loeschen"), enabled: true }
        ];

        return (
            <div className="flex-container">
                <Grid
                    standardButtons={standardButtons}
                    data={this.state.data}
                    options={this.gridOptions}
                    id="spesenGrid"
                    onClickStandardButton={this.onButtonClick}
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem: {Land}) => {

        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                const result = await HTTPService.get<JsonResultClass<SpesenViewModel>>(`GeneralSettings/GetSpese?land=${dataItem.Land}`);
                this.openSheet(result.Data)
                break;
            case ToolBarStandardButtonType.NEW:
                const spese: SpesenViewModel = {                    
                    AbzugAbend: 0,
                    AbzugFrueh: 0,
                    AbzugMittag: 0,
                    IsNew: true,
                    IsRowId: null,
                    IsWatchable: false,
                    IsWatched: false,
                    Land: "",
                    LandGruppe: 2,
                    Landkf: "",
                    Landkz: 0,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    },
                    Spesen1: 0,
                    Spesen2: 0,
                    Uebernachtung: 0,
                    IndividualFields: {},
                    Translations: []
                }
                this.openSheet(spese);
                break;
            case ToolBarStandardButtonType.DELETE:
                await this.delete(dataItem.Land);
                this.getAll()
                break;
        }


    }

    private openSheet = (dataItem: SpesenViewModel) => {
        const props: EditSpesenProps = {
            dataSources: {
                laenderGruppen: Object.keys(this.laenderGruppen).map((id) => {
                    return {
                        value: parseInt(id),
                        text: this.laenderGruppen[parseInt(id)]
                    }
                })
            },
            metadata: this.metaData,
            entity: dataItem,
            isWindow: true,
            context: {},
            title: dataItem.Land || Helper.getTranslation("Beleg.Spesen"),
            delete: this.delete
        }

        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, () => {
            this.getAll();
        });

        sheet.show(() => {
            sheet.mountContent(EditSpesen, props);
        });


    }

    private delete = async (land: string) => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk)
            return false;
        const result = await HTTPService.get<JsonResultClass>(`GeneralSettings/DeleteSpese?land=${land}`)
        return result.Code == 0;
    }

    render() {
        return this.renderGrid();
    }

}

class EditSpesen extends React.Component<EditSpesenProps, any>{
    private common = new AppHelper();

    constructor(props) {
        super(props);
        this.common.init(this);
    }

    save = async () => {
        if (this.common.validate()) {
            const result = await HTTPService.post<JsonResultClass<SpesenViewModel>>("GeneralSettings/SaveSpese", {
                model: this.props.entity
            });
            if (result.Code == 0) {
                this.props.entity.Translations = result.Data.Translations;
                this.props.entity.IsRowId = result.Data.IsRowId;
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"))
            } else {
                NotificationHelper.showErrorMessage(result.Message)
            }

            this.common.handlePostSave(result.Code === 0);
            this.setState({});
        }
    }

    remove = async () => {
        const isOk = await this.props.delete(this.props.entity.Land);
        if (isOk) {
            General.Sheet.Manager.getTopMostSheet().hide();
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => { //field.model
        if (!isInit) {
            this.common.handleFieldChange(field, value, dataItem);
        }
    }

    componentDidMount() {
        this.common.updateSheetTitle(this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditSpesenProps extends AppBaseProps {
    entity: SpesenViewModel;
    delete: (land: string) => Promise<boolean>;
}

interface SpesenViewModel extends Entity {
    Land: string;
    Landkz: number;
    Landkf: string;
    Spesen1: number; 
    Spesen2: number; 
    Uebernachtung: number; 
    AbzugFrueh: number; 
    AbzugMittag: number; 
    AbzugAbend: number; 
    LandGruppe: number; 
    IsRowId: number;
    Translations: any[];
}